import { ClientName } from '@/data/clientsData';
import { getEnv } from '@/runtime-config';

const LICARD_CLIENTS: ReadonlyArray<ClientName> = [
  ClientName.LICARD,
  ClientName.LICARD_UAT,
];

export function isLicardClient(): boolean {
  return LICARD_CLIENTS.includes(getEnv('CLIENT_NAME') as ClientName);
}
